/* global $ */ /* Bliss */
export default class ModalOverlay {
  constructor(contents) {
    this.element = this._create(contents)

    this.title = this.element.querySelector('.modal-overlay__title')
    this.text = this.element.querySelector('.modal-overlay__text')

    this._isVisible = false

    const closers = Array.prototype.slice.call(
      this.element.querySelectorAll('[data-modal-overlay-close]')
    )

    closers.forEach(closeEl => {
      closeEl.addEventListener('click', e => {
        e.preventDefault()
        this.hide()
      })
    })

    document.body.appendChild(this.element)
    window.addEventListener('keydown', this.handleKeydown)
  }

  get isVisible() {
    return this._isVisible
  }

  _create = contents => {
    return $.create('div', {
      className: 'modal-overlay',
      contents: [
        {
          tag: 'div',
          className: 'modal-overlay__window',
          contents: [
            {
              tag: 'div',
              className: 'modal-overlay__close',
              'data-modal-overlay-close': 'true',
              contents: [
                {
                  tag: 'div',
                  className: 'icon-bar first',
                },
                {
                  tag: 'div',
                  className: 'icon-bar',
                },
              ],
            },
            {
              tag: 'div',
              className: 'modal-overlay__body',
              contents: contents,
            },
          ],
        },
      ],
    })
  }

  handleKeydown = e => {
    if (this.isVisible && e.key == 'Escape') {
      this.hide()
    }
  }

  hide = () => {
    this._isVisible = false
    this.element.classList.remove('modal-overlay--visible')
  }
  show = () => {
    this._isVisible = true
    this.element.classList.add('modal-overlay--visible')
  }

  fadeIn = () => {
    this.element.classList.add('modal-overlay--fading-in')
    this.show()

    setTimeout(() => {
      this.fadeInDone()
    }, 300)
  }

  fadeInDone = () => {
    this.show()
    this.element.classList.remove('modal-overlay--fading-in')
  }

  setTitle = title => (this.title.textContent = title)
  setText = text => (this.text.textContent = text)
}
